import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetInvoiceEnhancedCsvChargesQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['bigint']['input'];
}>;


export type GetInvoiceEnhancedCsvChargesQuery = { __typename?: 'query_root', archarges: Array<{ __typename?: 'archarges', id: number, type: string, name: string, notes?: string | null, amount: number, source_type?: string | null, source_id?: number | null, billable_datetime: string, argroup: { __typename?: 'argroups', id: number, status: string, scenario_id?: number | null, program_id?: number | null, customer_id: number }, accessorial?: Array<{ __typename?: 'accessorials', id: number, move_id: number }> | null, ridehail?: Array<{ __typename?: 'ridehails', id: number, move?: { __typename?: 'moves', id: number, parent_move_id?: number | null } | null }> | null, guestride?: Array<{ __typename?: 'guestrides', id: number, reference_num?: string | null, pickup_address?: string | null, dropoff_address?: string | null }> | null }>, arcredits: Array<{ __typename?: 'arcredits', id: number, amount: number, reason: string, source_type?: string | null, source_id?: number | null, argroup: { __typename?: 'argroups', id: number, status: string, scenario_id?: number | null, program_id?: number | null, customer_id: number }, accessorial?: Array<{ __typename?: 'accessorials', id: number, move_id: number }> | null, ridehail?: Array<{ __typename?: 'ridehails', id: number, move?: { __typename?: 'moves', id: number, parent_move_id?: number | null } | null }> | null }> };


export const GetInvoiceEnhancedCsvChargesDocument = gql`
    query GetInvoiceEnhancedCsvCharges($invoiceId: bigint!) {
  archarges(
    where: {active: {_eq: true}, argroup: {arinvoice_id: {_eq: $invoiceId}, status: {_eq: "done"}}, type: {_neq: "processing_fee"}}
    order_by: [{billable_datetime: asc}, {id: asc}]
  ) {
    id
    type
    name
    notes
    amount
    source_type
    source_id
    billable_datetime
    argroup {
      id
      status
      scenario_id
      program_id
      customer_id
    }
    accessorial {
      id
      move_id
    }
    ridehail {
      id
      move {
        id
        parent_move_id
      }
    }
    guestride {
      id
      reference_num
      pickup_address
      dropoff_address
    }
  }
  arcredits(
    where: {active: {_eq: true}, argroup: {arinvoice_id: {_eq: $invoiceId}, status: {_eq: "done"}}}
    order_by: [{createdat: asc}, {id: asc}]
  ) {
    id
    amount
    reason
    source_type
    source_id
    argroup {
      id
      status
      scenario_id
      program_id
      customer_id
    }
    accessorial {
      id
      move_id
    }
    ridehail {
      id
      move {
        id
        parent_move_id
      }
    }
  }
}
    `;

/**
 * __useGetInvoiceEnhancedCsvChargesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceEnhancedCsvChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceEnhancedCsvChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceEnhancedCsvChargesQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoiceEnhancedCsvChargesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceEnhancedCsvChargesQuery, GetInvoiceEnhancedCsvChargesQueryVariables> & ({ variables: GetInvoiceEnhancedCsvChargesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceEnhancedCsvChargesQuery, GetInvoiceEnhancedCsvChargesQueryVariables>(GetInvoiceEnhancedCsvChargesDocument, options);
      }
export function useGetInvoiceEnhancedCsvChargesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceEnhancedCsvChargesQuery, GetInvoiceEnhancedCsvChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceEnhancedCsvChargesQuery, GetInvoiceEnhancedCsvChargesQueryVariables>(GetInvoiceEnhancedCsvChargesDocument, options);
        }
// @ts-ignore
export function useGetInvoiceEnhancedCsvChargesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoiceEnhancedCsvChargesQuery, GetInvoiceEnhancedCsvChargesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceEnhancedCsvChargesQuery, GetInvoiceEnhancedCsvChargesQueryVariables>;
export function useGetInvoiceEnhancedCsvChargesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceEnhancedCsvChargesQuery, GetInvoiceEnhancedCsvChargesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoiceEnhancedCsvChargesQuery | undefined, GetInvoiceEnhancedCsvChargesQueryVariables>;
export function useGetInvoiceEnhancedCsvChargesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoiceEnhancedCsvChargesQuery, GetInvoiceEnhancedCsvChargesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoiceEnhancedCsvChargesQuery, GetInvoiceEnhancedCsvChargesQueryVariables>(GetInvoiceEnhancedCsvChargesDocument, options);
        }
export type GetInvoiceEnhancedCsvChargesQueryHookResult = ReturnType<typeof useGetInvoiceEnhancedCsvChargesQuery>;
export type GetInvoiceEnhancedCsvChargesLazyQueryHookResult = ReturnType<typeof useGetInvoiceEnhancedCsvChargesLazyQuery>;
export type GetInvoiceEnhancedCsvChargesSuspenseQueryHookResult = ReturnType<typeof useGetInvoiceEnhancedCsvChargesSuspenseQuery>;
export type GetInvoiceEnhancedCsvChargesQueryResult = Apollo.QueryResult<GetInvoiceEnhancedCsvChargesQuery, GetInvoiceEnhancedCsvChargesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (archarges, arcredits): returns the full response object.
 * @source {@link src/features/invoices/queries/getInvoiceEnhancedCsvCharges.query.gql}
 */
export async function getInvoiceEnhancedCsvCharges(
  variables: GetInvoiceEnhancedCsvChargesQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetInvoiceEnhancedCsvChargesQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetInvoiceEnhancedCsvChargesQuery>(
    GetInvoiceEnhancedCsvChargesDocument,
    variables,
    requestOptions
  )
}